import * as React from 'react';
import { Datagrid, ListProps, NumberField, TextField, UrlField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';
import './TrainingMenuDatagrid.scss';

export const TrainingMenuDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="training-menus-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/>
			<TextField source="note" label="NOTE"/>
			<UrlField source="menuUrl" label="MENU_FILE"/>
			<TranslateField source="type" label="TYPE"/>
			<NumberField source="fromBMR" label="FROM_BMR"/>
			<NumberField source="toBMR" label="TO_BMR"/>
		</Datagrid>
	);
};
